/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TailoredDefragSummaryCard_org = {
    readonly id: string;
    readonly tailoredDefragCardSummary: ({
        readonly __typename: "TailoredDefragCardSummary";
        readonly defragTime: unknown;
        readonly impactedOtherCalendarIds: ReadonlyArray<string>;
        readonly valueStrings: ReadonlyArray<string>;
        readonly yourEventMoves: ReadonlyArray<{
            readonly newStartTime: {
                readonly dateOrDateTime: string;
            };
            readonly originalStartTime: {
                readonly dateOrDateTime: string;
            };
            readonly moveReasons: ReadonlyArray<string>;
            readonly addedRooms: ReadonlyArray<string>;
            readonly removedRooms: ReadonlyArray<string>;
            readonly event: {
                readonly title: string | null;
                readonly eventKey: {
                    readonly externalEventId: string;
                };
            };
            readonly " $fragmentRefs": FragmentRefs<"TailoredDefragSummaryEventsMovedList_eventsMoved">;
        }>;
        readonly persons: {
            readonly __typename: "PersonList";
            readonly list: ReadonlyArray<{
                readonly primaryEmail: string;
                readonly profile: {
                    readonly givenName: string | null;
                    readonly familyName: string | null;
                    readonly externalImageUrl: string | null;
                } | null;
            }>;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        };
        readonly rooms: {
            readonly __typename: "RoomList";
            readonly list: ReadonlyArray<{
                readonly roomId: string;
                readonly name: string;
            }>;
            readonly " $fragmentRefs": FragmentRefs<"TailoredDefragSummaryEventsMovedList_rooms">;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        };
        readonly " $fragmentRefs": FragmentRefs<"TailoredDefragSummaryAttendeeStats_tailoredDefragCardSummary">;
    } | {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
    readonly " $fragmentRefs": FragmentRefs<"TailoredDefragSummaryAttendeeStats_org">;
    readonly " $refType": "TailoredDefragSummaryCard_org";
};
export type TailoredDefragSummaryCard_org$data = TailoredDefragSummaryCard_org;
export type TailoredDefragSummaryCard_org$key = {
    readonly " $data"?: TailoredDefragSummaryCard_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TailoredDefragSummaryCard_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v1 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "TailoredDefragSummaryCard_org",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "tailoredDefragCardSummary",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "defragTime",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "impactedOtherCalendarIds",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "valueStrings",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DefragExplainedMove",
                                "kind": "LinkedField",
                                "name": "yourEventMoves",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventTime",
                                        "kind": "LinkedField",
                                        "name": "newStartTime",
                                        "plural": false,
                                        "selections": (v1 /*: any*/),
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventTime",
                                        "kind": "LinkedField",
                                        "name": "originalStartTime",
                                        "plural": false,
                                        "selections": (v1 /*: any*/),
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "moveReasons",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "addedRooms",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "removedRooms",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Event",
                                        "kind": "LinkedField",
                                        "name": "event",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "title",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "EventKey",
                                                "kind": "LinkedField",
                                                "name": "eventKey",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "externalEventId",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "TailoredDefragSummaryEventsMovedList_eventsMoved"
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "persons",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Person",
                                                "kind": "LinkedField",
                                                "name": "list",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "primaryEmail",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "UserProfile",
                                                        "kind": "LinkedField",
                                                        "name": "profile",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "givenName",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "familyName",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "externalImageUrl",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "type": "PersonList",
                                        "abstractKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "rooms",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Room",
                                                "kind": "LinkedField",
                                                "name": "list",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "roomId",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "name",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "TailoredDefragSummaryEventsMovedList_rooms"
                                            }
                                        ],
                                        "type": "RoomList",
                                        "abstractKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "TailoredDefragSummaryAttendeeStats_tailoredDefragCardSummary"
                            }
                        ],
                        "type": "TailoredDefragCardSummary",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "message",
                                "storageKey": null
                            }
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TailoredDefragSummaryAttendeeStats_org"
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '7fbd00e2c67114d782dcf3184eb72f7e';
export default node;
